<template>
  <w-icon-wrapper
    :height='24'
    :width='20'
    icon-name='work-edit-mode-off-icon'
    view-box='0 0 20 24'
  >
    <g
      id='_35_Edit-Mode-Off_Icon'
      data-name='35 Edit-Mode-Off_Icon'
      transform='translate(-1.833)'
    >
      <path
        id='Pfad_55863'
        d="M20,22H4v-.88a1,1,0,0,0-2,0V24H22V21.12a1,1,0,0,0-2,0ZM2,0V9.12a1,1,0,0,0,2,0V2H20V9.12a1,1,0,1,0,2,0V0Z"
        fill="currentColor"
      />
      <path
        id='Pfad_55864'
        d='M7.005,5.995H17a1,1,0,0,0,0-2h-10a1,1,0,0,0,0,2'
        data-name='Pfad 55864'
        fill='currentColor'
      />
      <path
        id='Pfad_55865'
        d='M7.005,8.995h7a1,1,0,0,0,0-2h-7a1,1,0,0,0,0,2'
        data-name='Pfad 55865'
        fill='currentColor'
      />
      <path
        id='Pfad_55866'
        d='M23,14.04h-.98a4.866,4.866,0,0,0-9.53,0h-1.1a4.86,4.86,0,0,0-9.52,0H1a1,1,0,0,0,0,2h.87a4.862,4.862,0,0,0,9.52,0h1.1a4.868,4.868,0,0,0,9.53,0H23a1,1,0,0,0,0-2m-13.68,2a2.87,2.87,0,0,1-5.38,0,2.868,2.868,0,0,1,0-2,2.864,2.864,0,0,1,5.38,0,2.868,2.868,0,0,1,0,2m10.62,0a2.87,2.87,0,0,1-5.38,0,2.868,2.868,0,0,1,0-2,2.872,2.872,0,0,1,5.39,0,2.772,2.772,0,0,1,.18,1,2.58,2.58,0,0,1-.19,1'
        data-name='Pfad 55866'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconEditModeOn' };
</script>
